<mg-sr-filters-wrap
  [form]="form"
  [filters]="filters$ | async">
  <ng-container *ngIf="form.get(PARENT_FIELDS.REPORT_FILTERS)">
    <mg-multi-person-search
      *ngIf="((defaultValues$ | async).reportType !== TARDY_REPORT) && form.get(getFilterGroupControlKey(FIELDS.ISSUED_TO)) && defaultIssuedHashes$ | async"
      (selectionChanged)="onPersonSelected($event)"
      [defaultValue]="defaultIssuedHashes$ | async">
    </mg-multi-person-search>
    <mg-form-select
      [placeholder]="MESSAGES.REASON"
      [value]="form.get(getFilterGroupControlKey(FIELDS.REASON)).value"
      [closeOnSelect]="true"
      [multiple]="true"
      [searchable]="false"
      [isFullWidth]="true"
      [isClearable]="true"
      [control]="form.get(getFilterGroupControlKey(FIELDS.REASON))"
      [options]="reasonOptions$ | async">
    </mg-form-select>
    <mg-form-select
      *ngIf="(defaultValues$ | async).reportType !== TARDY_REPORT"
      [placeholder]="MESSAGES.ROLE"
      [value]="form.get(getFilterGroupControlKey(FIELDS.ROLE)).value"
      [closeOnSelect]="true"
      [multiple]="true"
      [searchable]="false"
      [isFullWidth]="true"
      [isClearable]="true"
      [control]="form.get(getFilterGroupControlKey(FIELDS.ROLE))"
      [options]="roleOptions$ | async">
    </mg-form-select>
    <mg-form-select
      *ngIf="(defaultValues$ | async).reportType !== TARDY_REPORT"
      [isClearable]="true"
      [options]="gradeOptions$ | async"
      [multiple]="true"
      [isFullWidth]="true"
      [control]="form.get(getFilterGroupControlKey(FIELDS.GRADE))"
      [value]="form.get(getFilterGroupControlKey(FIELDS.GRADE)).value"
      [placeholder]="MESSAGES.GRADE">
    </mg-form-select>
    <mg-user-list-filter
      [prefetchData]="[UserListCategory.ALL]"
      [placeholder]="MESSAGES.USER_LIST"
      [value]="form.get(getFilterGroupControlKey(FIELDS.USER_LIST)).value"
      (selectChanged)="form.get(getFilterGroupControlKey(FIELDS.USER_LIST)).setValue($event)">
    </mg-user-list-filter>
  </ng-container>
</mg-sr-filters-wrap>
